// CheckoutForm.jsx
import React from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { useLocation } from 'react-router-dom';

const CheckoutForm = ({ orderId, onPaymentSuccess, setCompletePayment }) => {
    const location = useLocation();
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) return;
        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `https://farmers-admin.csdevhub.com/success?orderId=${orderId}`,
            },
        });

        // if (result.error) {
        //     console.log(result.error, "error");
        //     // Show error to user
        // }
        // else if (result.paymentIntent?.status === 'succeeded') {
        //     console.log("Payment successful!");
        //     onPaymentSuccess?.();
        //     setCompletePayment(true)
        // }
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />
            <button className="primary-btn mt-3 py-2" disabled={!stripe}>Pay</button>
        </form>
    );
};

export default CheckoutForm;
